export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_08.4df9fc89.jpg";